import { createAsyncThunk } from "@reduxjs/toolkit";
import { memberApi } from "api/member";
import { MemberPayload } from "types/member";

export const getMessageMember = createAsyncThunk(
  "member/getMessageMember",
  async (data: MemberPayload, { rejectWithValue }) => {
    try {
      const dataMessageMember = await memberApi.getMessageMember(
        data.username,
        data
      );
      return dataMessageMember;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getPromotionMember = createAsyncThunk(
  "member/getPromotionMember",
  async (data: MemberPayload, { rejectWithValue }) => {
    try {
      const dataPromotionMember = await memberApi.getPromotionMember(
        data.username,
        data
      );
      return dataPromotionMember;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getVipMember = createAsyncThunk(
  "member/getVipMember",
  async (data: MemberPayload, { rejectWithValue }) => {
    try {
      const dataVipMember = await memberApi.getMemberVip(data.username, data);
      return dataVipMember;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
